import React from "react";

const Es = "es";
const En = "en";

export const translations = {
    en: {
       button: {
            "cancel": "Cancel",
            "sendRequest": "Send Request",
            "endLiveChat": "End Live Chat",
       }, 
       LiveChatCard: {        
            "header": "Live Chat Request", 
            "firstName": "First Name",
            "lastName": "Last Name",
            "Customer": "New or Existing Consumer?",
            "liveChatReason": "Reason for Live Chat",
            "startLiveChat": "Start Live Chat",
            "privacyStatement": "Privacy Statement",
            "privacyStatementText":
                "Privacy Statement",
            },
        LiveChatCard1: {
           "livechartStarted": "Live Chat Started",
           "welcomeText": "Welcome to Live Chat.",
        },
        LiveChatCard2: {
            "livechatEnded": "Live Chat Ended",
            "welcomeBack": "Welcome back.",
        },
        customerTypeDropdown: [
            { label: "New Consumer", value: "New Consumer" },
            { label: "Existing Consumer", value: "Existing Consumer" },
            { label: "Medi-Cal Consumer", value: "Medi-Cal Consumer" },
          ],
          liveChatTopicDropdown: {
            "New Consumer": [
              { label: "Check Application Status", value: "Check Application Status" },
              { label: "General Information", value: "General Information" },
              { label: "Reset Password", value: "Reset Password" },
              {
                label: "Determine your potential program eligibility",
                value: "Determine your potential program eligibility",
              },
            ],
            "Existing Consumer": [
              { label: "Reset Password", value: "Reset Password" },
              { label: "Report a Change", value: "Report a Change" },
              { label: "Check Application Status", value: "Check Application Status" },
              {
                label: "1095/3895 Tax Document Help",
                value: "1095/3895 Tax Document Help",
              },
              { label: "Renew Coverage", value: "Renew Coverage" },
              { label: "Other Questions", value: "Other Questions" },
            ],
            "Medi-Cal Consumer": [
              { label: "Check Status", value: "Check Status" },
              { label: "Other Questions", value: "Other Questions" },
            ],
          },
          closeModal: {
            "endLiveChat": "End live chat?",
            "continueWithVirtualAssistant":
                "You'll continue with our virtual assistant after this chat.",
            "endLiveChatButton": "End live chat",
            "cancelButton": "Cancel",
        },  
        privacyStatementModal: {
            "privacyStatement": "Privacy Statement",
    "privacyStatementText": `The information requested on this form is required by Covered California to assist
                            with your request, and the information you provide will be used by Covered California solely for that purpose.
                            Legal references authorizing the collection of the personally-identifiable information through this form include
                            Sections 1798.22, 1798.25, 1798.27 and 1798.35 of the California Civil Code and Section 155.260(a) of the Code
                            of Federal Regulations. California Health Benefits Exchange dba Covered California, 1601 Exposition Blvd,
                            Sacramento, CA 95815 (800) 889-3871.`

        },
    },

    es: {
         button: {
                "cancel": "Cancelar",
                "sendRequest": "Enviar",
                "endLiveChat": "¿Terminar chat en vivo",
         },
        LiveChatCard: { 
            "header": "Solicitud de Chat en Vivo",
            "firstName": "Nombre",
            "lastName": "Apellido",
            "Customer": "¿Cliente nuevo o existente?",
            "liveChatReason": "Motivo para el chat en vivo",
            "startLiveChat": "Iniciar Chat en Vivo",
            "privacyStatement": "Declaración de Privacidad",
            "privacyStatementText":
                "Declaración de Privacidad",
        },
        LiveChatCard1: {
            "livechartStarted": "Chat en Vivo Iniciado",
            "welcomeText": "Te damos la bienvenida al Chat en vivo..",
        },
        LiveChatCard2: {
            "livechatEnded": "Chat en Vivo Finalizado",
            "welcomeBack": "¡Hola de nuevo!",
        },
        customerTypeDropdown: [
            { label: "Persona inscrita nueva", value: "New Consumer" },
            { label: "Persona inscrita existente",  value: "Existing Consumer" },
            { label: "Persona inscrita en Medi-Cal",  value: "Medi-Cal Consumer" },
                ],
                customerTypeDropdown: [
                    { label: "Persona inscrita nueva", value: "New Consumer" },
                    { label: "Persona inscrita existente", value: "Existing Consumer" },
                    { label: "Persona inscrita en Medi-Cal", value: "Medi-Cal Consumer" },
                  ],
                  
                  liveChatTopicDropdown: {
                    "New Consumer": [
                      { label: "Revisar el estatus de la aplicación", value: "Check Application Status" },
                      { label: "Información general", value: "General Information" },
                      { label: "Restablecer contraseña", value: "Reset Password" },
                      {
                        label: "Revisar si soy elegible para el programa",
                        value: "Determine your potential program eligibility",
                      },
                    ],
                    "Existing Consumer": [
                      { label: "Restablecer contraseña", value: "Reset Password" },
                      { label: "Actualizar mi información", value: "Report a Change" },
                      { label: "Revisar el estatus de la aplicación", value: "Check Application Status" },
                      {
                        label: "Ayuda con el documento fiscal 1095/3895",
                        value: "1095/3895 Tax Document Help",
                      },
                      { label: "Renovar cobertura", value: "Renew Coverage" },
                      { label: "Otras preguntas", value: "Other Questions" },
                    ],
                    "Medi-Cal Consumer": [
                      { label: "Revisar estatus", value: "Check Status" },
                      { label: "Otras preguntas", value: "Other Questions" },
                    ],
                  },
        closeModal: {
            "endLiveChat": "¿Cerrar chat en vivo?",
           "continueWithVirtualAssistant": "Continuarás con nuestro asistente virtual después de este chat.",

            "endLiveChatButton": "Terminar chat en vivo",
            "cancelButton": "Cancelar",
        },
        privacyStatementModal: {
            "privacyStatement": "Declaración de Privacidad",
            "privacyStatementText":
                "La información solicitada en este formulario es requerida por Covered California para procesar tu solicitud y será utilizada solo para ese propósito. Las leyes que autorizan la recopilación de información indentificable incluyen las Secciones 1798.22, 1798.25, 1798.27 y 1798.35 del Código Civil de California, así como la Sección 155.260(a) del Código de Regulaciones Federales. California Health Benefits Exchange, dba Covered California, 1601 Exposition Blvd, Sacramento, CA 95815, (800) 889-3871.",
        },
                  
    },
};

export default translations;